module.exports = __webpack_public_path__ + "static/media/speech_01.ee2b7660.png";